import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from '@greco/ui-table';

@NgModule({ imports: [CommonModule, TableModule] })
export class CommunityServiceModule {}
